var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.style==='link')?_c('a',{style:([
    {fontSize: _vm.item.size, fontWeight: _vm.item.weight},
    _vm.item.color?{backgroundColor: _vm.item.color}:{},
    _vm.item.height?{
      height: _vm.item.height === 'sm' ? '40px' : '52px'
    }:{}
  ])},[_vm._v(_vm._s(_vm.item.action.label))]):_c('button',{class:_vm.item.style,style:([
    {fontSize: _vm.item.size, fontWeight: _vm.item.weight},
    _vm.item.color?{color: _vm.item.color}:{}
  ])},[_vm._v(_vm._s(_vm.item.action.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }